"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosSearchSettingsSchema = exports.APosSearchResultSchema = exports.APosSearchRequestSchema = exports.TYPESENSE_FIELD_TYPES = exports.APosSearchDocumentSchema = void 0;
const zod_1 = require("zod");
// ── Typesense document schema ──────────────────────────────────────
// This is the single source of truth for what gets indexed in Typesense.
// products-service-ext/src/utils/indexing.ts derives the Typesense
// collection fields and document mapping from this schema.
//
// Fields match the actual `indexVariants()` output — if you add a field
// here, also update the `toTypesenseField()` mapper in indexing.ts.
exports.APosSearchDocumentSchema = zod_1.z.object({
    id: zod_1.z.string(), // {productId}_{variantId}
    productId: zod_1.z.string(),
    variantId: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    name: zod_1.z.string(), // product.name
    displayName: zod_1.z.string(), // variant.displayName
    sku: zod_1.z.string(), // variant.sku ('' if missing)
    categoryId: zod_1.z.string(), // product.categoryId ('' if missing)
    brandId: zod_1.z.string(), // product.brandId ('' if missing)
    costPrice: zod_1.z.number(), // variant.costPrice (0 if missing)
    images: zod_1.z.array(zod_1.z.string()), // product.images ([] if missing)
    barcode: zod_1.z.string(), // variant.barcode ('' if missing)
    status: zod_1.z.literal('active'), // only active products are indexed
    createdAt: zod_1.z.number().optional(), // product.createdAt (epoch ms)
    createdByName: zod_1.z.string().optional(), // product.createdByName
    createdByEmail: zod_1.z.string().optional(), // product.createdByEmail
    lastPublishedByName: zod_1.z.string().optional(), // product.lastPublishedByName
    lastPublishedByEmail: zod_1.z.string().optional(), // product.lastPublishedByEmail
});
// Typesense field type mapping derived from Zod schema
// Used by products-service-ext indexing.ts to build the collection schema
exports.TYPESENSE_FIELD_TYPES = {
    id: { type: 'string' },
    productId: { type: 'string' },
    variantId: { type: 'string' },
    tenantId: { type: 'string' },
    name: { type: 'string' },
    displayName: { type: 'string' },
    sku: { type: 'string' },
    categoryId: { type: 'string' },
    brandId: { type: 'string' },
    costPrice: { type: 'float' },
    images: { type: 'string[]' },
    barcode: { type: 'string' },
    status: { type: 'string' },
    createdAt: { type: 'int64', optional: true },
    createdByName: { type: 'string', optional: true },
    createdByEmail: { type: 'string', optional: true },
    lastPublishedByName: { type: 'string', optional: true },
    lastPublishedByEmail: { type: 'string', optional: true },
};
// ── Search request/result schemas ──────────────────────────────────
exports.APosSearchRequestSchema = zod_1.z.object({
    query: zod_1.z.string().min(1).max(200),
    tenantId: zod_1.z.string(),
    filters: zod_1.z.object({
        categoryId: zod_1.z.string().optional(),
        brandId: zod_1.z.string().optional(),
        status: zod_1.z.literal('active').optional(),
        minCostPrice: zod_1.z.number().optional(),
        maxCostPrice: zod_1.z.number().optional(),
    }).optional(),
    page: zod_1.z.number().int().min(1).default(1),
    perPage: zod_1.z.number().int().min(1).max(100).default(20),
    sortBy: zod_1.z.enum(['_text_match', 'costPrice', 'createdAt', 'displayName']).default('_text_match'),
    sortOrder: zod_1.z.enum(['asc', 'desc']).default('desc'),
});
exports.APosSearchResultSchema = zod_1.z.object({
    hits: zod_1.z.array(zod_1.z.object({
        document: exports.APosSearchDocumentSchema,
        highlight: zod_1.z.record(zod_1.z.string(), zod_1.z.object({
            snippet: zod_1.z.string().optional(),
            matchedTokens: zod_1.z.array(zod_1.z.string()).optional(),
        })).optional(),
        textMatch: zod_1.z.number().optional(),
    })),
    found: zod_1.z.number(),
    page: zod_1.z.number(),
    searchTimeMs: zod_1.z.number(),
});
exports.APosSearchSettingsSchema = zod_1.z.object({
    id: zod_1.z.literal('search_settings'),
    provider: zod_1.z.literal('typesense_cloud'),
    typesenseHost: zod_1.z.string(),
    typesenseApiKey: zod_1.z.string(),
    typesenseSearchKey: zod_1.z.string(),
    collectionPrefix: zod_1.z.string().default('product_variants'),
    configured: zod_1.z.boolean().default(false),
    updatedAt: zod_1.z.number().optional(),
    updatedBy: zod_1.z.string().optional(),
});
//# sourceMappingURL=search-document.schema.js.map